'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const ServerRequest = (function() {
	const dev = false;
	/**
	 * Private variable, holds the APIs endpoints.
	 */
    const routes = {
		// ddt
		// 'districts_index': '/api_districts/get_districts',
		'login':'/get_token',
		'logout':'/invalidate_tokens',
		'user_detaile':'/user_info',
		'save_user':'/user_store',
		'update_user':'/user_update',
		'delete_user':'/user_delete',
		'events':'/events',
		'save_event':'/events/store',
		'update_event':'/events/update',
		'delete_event':'/events/delete',
		'orders':'/orders',
		'save_order':'/orders/store',
		'delete_order':'/orders/delete'
	}
	
	/**
	 * returns the map of the apis
	 */
    // function getRoutes(){
    //     return routes;
	// }

	/**
	 * 
	 * @param endPoint
	 * @param token 
	 * @param params object of data to be passed with the request. Goes in the request body a JSON string.
	 */
	function get(endPoint,token, params) {
	 
		// let base = 'http://localhost/manicomix/public';
		let base = getCurrentBasePath();
		let url = base + endPoint;
		
		// specifico che si tratta di una richiesta API
		params.apiFetch = true;

		return fetch(url, {
			method: 'GET',
			headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json',
			// 'mode': 'no-cors',
			'Authorization': 'Bearer ' + token
			},
			params: JSON.stringify(params)
		}).then( resp => { 
			//console.log(resp);
			return resp.json();
		}).catch( err => { 
			console.log(err);
			return null; 
		});
	}

	/**
	 * 
	 * @param endPoint 
	 * @param data 
	 */
	function post(endPoint, token, data){
		
		let base = getCurrentBasePath();
		let url = base + endPoint;
		// let token = $('meta[name="csrf-token"]').attr('content');
		return fetch(url, {
			method: 'POST',
			headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json',
			// 'mode': 'no-cors',
			'Authorization': 'Bearer ' + token
			},
			body: JSON.stringify(data)
		}).then( resp => { 
			// console.log(resp);
			return resp.json();
		}).catch( err => { 
			console.log(err) 
			return null;
		});
	}


	/**
	 * 
	 * @returns $path The backedn basepath
	 */
	function getCurrentBasePath(){

		if( dev ) 
			return 'http://localhost:80/apidatastore/public/api/v1';

		return 'https://apidatastore.anatolieghebea.com/api/v1';
	}

    return {
		routes: routes,
        get: get,
		post: post, 
		getCurrentBasePath: getCurrentBasePath
        
    };
})();

exports.ServerRequest = ServerRequest;